<template>
  <div class="counter-list-container">
    <div v-if="!hiddenTitle" class="title-container">
      <div class="title">{{ $t(titleI18nKey) }}</div>
      <div class="title-btn-container">
        <slot name="titleBtn"></slot>
      </div>
    </div>
    <div class="counter-list" :class="hiddenLineDivider && 'no-line-divider'">
      <div v-for="(line, lineIndex) in lines" ref="line" class="counter-list-line" :key="lineIndex">
        <Counter
          v-for="(item, index) in line"
          class="counter"
          :key="index"
          :labelI18nKey="item.labelI18nKey"
          :value="item.value"
          :showRightArrow="item.showRightArrow"
          :valueColor="item.valueColor"
          :arrowColor="item.arrowColor"
          :minutes="item.minutes"
          @rightClick="onCounterRightClick(item, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Counter from './counter.vue'

export default {
  components: {
    Counter
  },
  props: {
    hiddenTitle: {
      type: Boolean,
      default: false
    },
    titleI18nKey: {
      type: String,
      required: true
    },
    hiddenLineDivider: {
      type: Boolean,
      default: false
    },
    maxInLine: {
      type: Number,
      default: 4
    },
    data: {
      type: Array,
      required: true
    },
    countArray: {
      type: Array,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    lines () {
      let lineList = []
      if (!this.countArray) {
        lineList = _.chunk(this.data, this.maxInLine)
      } else {
        let tempList = this.data
        this.countArray.forEach(element => {
          lineList.push(_.take(tempList, element))
          tempList = _.drop(tempList, element)
        })
        lineList = _.concat(lineList, ..._.chunk(tempList, this.maxInLine))
      }
      return lineList
    },
    lineItemWidth () {
      const gap = 1.5
      return `${100 / this.maxInLine - gap}%`
    }
  },
  created () {

  },
  methods: {
    onCounterRightClick (counterInfo, $event) {
      if (counterInfo.onRightClick) {
        counterInfo.onRightClick(counterInfo, $event)
      } else {
        this.$emit('counterRightClick', counterInfo, $event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.counter-list-container {
  $border-color: #dcdfe6;
  display: flex;
  flex-direction: column;

  .title-container {
    display: flex;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid $border-color;

    .title {
      font-size: 16px;
    }

    .title-btn-container {
      margin-left: auto;
      margin-right: 0;
    }
  }

  .counter-list {
    flex: 1;

    &.no-line-divider {
      .counter-list-line {
        &:not(:first-child) {
          margin-top: 0;
          padding-top: 0;
          border-top: 0;
        }
      }
    }

    .counter-list-line {
      display: flex;
      margin-right: 1.5%;

      &:not(:first-child) {
        margin-top: 25px;
        padding-top: 25px;
        border-top: 1px solid $border-color;
      }
    }
  }
}
</style>
